import { render, staticRenderFns } from "./UiContent.vue?vue&type=template&id=67daec36"
import script from "./UiContent.vue?vue&type=script&lang=js"
export * from "./UiContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports